export const NOTIFICATION_TYPES = {
  success: "success",
  error: "error",
  info: "info",
};
